import { IInput } from '../../Services/FormikValidatorService';

interface IPaging {
  currentPage: number;
  pagesTotal: number;
  rowsPerPage: number;
  rowsTotal: number;
}

interface IAction {
  disabled: boolean;
  icon: string;
  id: string;
  link: string | null;
  title: string;
  type: string;
}

interface ISummaryColumn {
  name: string;
  value: null | string;
}

interface ICorrectionRecord {
  actions: IAction[];
  appliedAt: string;
  assignedToRide: string;
  attachments: any[];
  createdAt: string;
  createdBy: number;
  customerId: number;
  diffAbs: null | string;
  diffPerc: null | string;
  id: number;
  lastAffectedRideId: number | string;
  lat: number;
  licenceNumber: number;
  links: { assignedToRide: string };
  locked: string;
  lon: number;
  mileage: string;
  mileageOriginal: number;
  modifiedAt: null | string;
  modifiedBy: null | number;
  positionCount: number;
  rideCount: number;
  rideMaxTs: null | string;
  rideMinTs: null | string;
  rideSource: string;
  source: string;
  timestamp: string;
  type: string;
  vehicleId: number;
  vehicleName: number;
}

export interface ICorrectionDataApiResponse {
  paging: IPaging;
  records: ICorrectionRecord[];
  status: 200;
  warning?: any;
}

interface IExport {
  actionUrl: string | null;
  enabled: boolean;
  fileName: string;
  formats: string[];
}

interface IFilter {
  active: boolean;
  filtered?: boolean;
  multiple?: boolean;
  placeholder?: string | null;
  required: boolean;
  selectedValue: any;
  title: string;
  type: string;
  values?: { item: string; value: any; label?: string | null; customerLabel?: string | null }[];
  maxDate?: string;
  minDate?: string;
  maxTitle?: string;
  maxValue?: number;
  minTitle?: string;
  minValue?: number;
  regex?: null | string;
  sign?: null | string;
  signPlacement?: string;
  subType?: string;
}

interface IColumn {
  filter: null | IFilter;
  name: string;
  required: boolean;
  searchable: boolean;
  sortable: boolean;
  system: boolean;
  title: string;
  type: string;
  visible: boolean;
}

interface ICorrectionColumn {
  appliedAt: IColumn;
  assignedToRide: IColumn;
  attachments: IColumn;
  createdAt: IColumn;
  createdBy: IColumn;
  customerId: IColumn;
  diffAbs: IColumn;
  diffPerc: IColumn;
  error: IColumn;
  id: IColumn;
  lastAffectedRideId: IColumn;
  licenceNumber: IColumn;
  locked: IColumn;
  mileage: IColumn;
  mileageOriginal: IColumn;
  modifiedAt: IColumn;
  modifiedBy: IColumn;
  prevCorrectionMileage: IColumn;
  source: IColumn;
  timestamp: IColumn;
  type: IColumn;
  vehicleId: IColumn;
  vehicleName: IColumn;
}

export interface ICorrectionSettingsApiResponse {
  actions: { multipleActions: IAction[]; rowActions: { maxActionCountPerRow: number } };
  columns: ICorrectionColumn;
  export: IExport;
  sorting: { [key: string]: string }[];
  status: 200;
  userSettingsKey: string;
}

export const handleFormDataCorrection = (formData, typeKey: string) => {
  return {
    existingCorrection: formData.find((i: IInput) => i.indexId === 'existingCorrection')?.[typeKey],
    timestamp: formData.find((i: IInput) => i.indexId === 'timestamp')?.[typeKey],
    vehicleId: formData.find((i: IInput) => i.indexId === 'vehicleId')?.[typeKey],
    type: formData.find((i: IInput) => i.indexId === 'type')?.[typeKey],
    lastAffectedRideId: formData.find((i: IInput) => i.indexId === 'lastAffectedRideId')?.[typeKey],
    mileageOrig: formData.find((i: IInput) => i.indexId === 'mileageOrig')?.[typeKey],
    mileage: formData.find((i: IInput) => i.indexId === 'mileage')?.[typeKey],
    lockedStatus: formData.find((i: IInput) => i.indexId === 'lockedStatus')?.[typeKey],
    attachments: formData.find((i: IInput) => i.indexId === 'attachments')?.[typeKey],
  };
};
